import React from "react";
import { FastField } from "formik";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import Typography from "@mui/material/Typography";

export default function BooleanField({ name, disabled, label, className, ...props }) {
  return (
    <FormControl fullWidth>
      <FormControlLabel
        sx={{ mb: 0 }}
        className={className}
        control={
          <FastField type="checkbox" name={name} disabled={disabled} {...props}>
            {({ field }) => (
              <Checkbox
                {...field}
                sx={{ p: 1, ...props.sx }}
                onChange={e =>
                  field.onChange({
                    ...e,
                    target: {
                      ...e.target,
                      name: field.name,
                      value: e.target.checked,
                    },
                  })
                }
                {...props}
              />
            )}
          </FastField>
        }
        label={
          <Typography color="textSecondary" variant="body2">
            {label}
          </Typography>
        }
      />
    </FormControl>
  );
}
